module.exports = __webpack_public_path__ + "img/projecto-1.4e532471.png";